<script setup>
import {ref, defineProps} from 'vue'
import moment from "moment/moment";
import getApk from "@/utils/getApk";
import {useRouter} from "vue-router";
import {useTgaStore} from "@/store/tga";
import useAccount from "@/store/account";
const router = useRouter()
const tga = useTgaStore()
const accountStore = useAccount();
const emits = defineEmits(['on-click'])

const props = defineProps({
  type: {
    type: String,
    required: true,
  }
})

const menuIndex = ref(0);

const change = (index) => {
  menuIndex.value = index;
  emits('on-click', index)
}

const handleDownAndroid = () => {

  let pageName = '';
  if (props.type == 'News') {
    pageName = '新闻'
  } else if (props.type == 'PlayerCenter') {
    pageName = '玩家中心'
  } else if (props.type == 'Information') {
    pageName = '游戏资料'
  } else if (props.type == 'TopUp') {
    pageName = '充值中心'
  }

  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_android_download',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: pageName
  })

  // 十秒钟后的时间戳
  const timestamp = moment(moment().add(900, 'seconds').format('YYYY-MM-DD HH:mm:ss')).unix().toString(16)
  const aUrl = getApk(timestamp, "/res-patch/release/jqys_v4/apks/projectb_ysa_release.apk")
  location.href = aUrl
}

const handleDownIos = () => {
  let pageName = '';
  if (props.type == 'News') {
    pageName = '新闻'
  } else if (props.type == 'PlayerCenter') {
    pageName = '玩家中心'
  } else if (props.type == 'Information') {
    pageName = '游戏资料'
  } else if (props.type == 'TopUp') {
    pageName = '充值中心'
  }
  // 用户存在，上报
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_ios_download',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: pageName
  })


  window.location.href = "https://apps.apple.com/cn/app/id6443768967"
}

const handleJumpTopUp = () => {
  router.push({path: '/top-up'})
}

</script>

<template>
<div class="menu_block">
  <template v-if="props.type == 'News'">
    <div :class="{'menu_item': true, 'active': menuIndex == 0}" @click="change(0)">赛季更新</div>
  </template>
  <template v-if="props.type == 'PlayerCenter'">
    <div :class="{'menu_item': true, 'active': menuIndex == 0}" @click="change(0)">玩家攻略</div>
    <div :class="{'menu_item': true, 'active': menuIndex == 1}" @click="change(1)">游戏壁纸</div>
  </template>
  <template v-if="props.type == 'Information'">
    <div :class="{'menu_item': true, 'active': menuIndex == 0}" @click="change(0)">球员展示</div>
  </template>
  <template v-if="props.type == 'TopUp'">
    <div :class="{'menu_item': true, 'active': menuIndex == 0}" @click="change(0)">充值中心</div>
  </template>


  <img src="@/assets/newPc/left_menu_android.png" @click="handleDownAndroid" alt="">
  <img src="@/assets/newPc/left_menu_ios.png" @click="handleDownIos" alt="">
  <img src="@/assets/newPc/left_menu_top_up.png" @click="handleJumpTopUp" alt="">
</div>
</template>

<style scoped lang="scss">
.menu_block {
  width: 7.2265625vw;
  height: 26.796875vw;
  background: transparent url("@/assets/newPc/left_menu_bg.png") no-repeat top center;
  background-size: cover;


  .menu_item {
    padding-left: 1.171875vw;
    font-family: 'YouSheBiaoTiHei';
    font-size: 1.2890625vw;
    color: #fff;
    height: 2.1875vw;
    line-height: 2.1875vw;
    width: 9.6484375vw;
    margin-bottom: 0.78125vw;
    cursor: pointer;

    &.active {
      background: transparent url("@/assets/newPc/left_menu_active_bg.png") no-repeat center center;
      background-size: cover;
      color: #E8FF24;
      font-size: 1.6015625vw;
    }
  }



  img {
    width: 6.2109375vw;
    height: 2.0703125vw;
    margin-left: 0.546875vw;
    margin-bottom: 0.2734375vw;
  }
}
</style>